// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file notifications/notification_response.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';

/**
 * Describes the file notifications/notification_response.proto.
 */
export const file_notifications_notification_response: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Cilub3RpZmljYXRpb25zL25vdGlmaWNhdGlvbl9yZXNwb25zZS5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiVQoRUHVzaFRva2VuUmVzcG9uc2USOAoHc3VjY2VzcxgBIAEoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkJvb2xlYW5SZXNwb25zZUgAQgYKBHR5cGVCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_common_common_responses]
  );

/**
 * @generated from message com.gem.bff.contract.PushTokenResponse
 */
export type PushTokenResponse = Message<'com.gem.bff.contract.PushTokenResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.PushTokenResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.PushTokenResponse.
 * Use `create(PushTokenResponseSchema)` to create a new message.
 */
export const PushTokenResponseSchema: GenMessage<PushTokenResponse> =
  /*@__PURE__*/
  messageDesc(file_notifications_notification_response, 0);
